import React from "react";

function Delete() {
  return (
    <div>
      <div class="deletebox">
        <h1>Delete your account</h1>
        <p>
          If you'd like to delete your account, please{" "}
          <a href="mailto:resolutionimprovelifecare@gmail.com?subject=Request%20to%20Delete%20Account&body=Please%20delete%20my%20account.">
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default Delete;
